import {GroupIWL} from 'ApplicationEntry/models/ProductsRiders/IWL/GroupIWL';
import {NewYorkIWL} from 'ApplicationEntry/models/ProductsRiders/IWL/NewYorkIWL';
import {OrdinaryIwl} from 'ApplicationEntry/models/ProductsRiders/IWL/OrdinaryIWL';

export type IWL = OrdinaryIwl | GroupIWL | NewYorkIWL;

type ExhaustiveIWLOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdinaryIwl) => TReturn;
  Group: (group: GroupIWL) => TReturn;
  NewYork: (newYork: NewYorkIWL) => TReturn;
};

type PartialIWLOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdinaryIwl) => TReturn;
  Group?: (group: GroupIWL) => TReturn;
  NewYork?: (newYork: NewYorkIWL) => TReturn;
  _: (app: IWL) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: IWLByTypeOptions<TReturn>
): options is ExhaustiveIWLOptionsByType<TReturn> => !!options.Ordinary || (!!options.Group && !!options.NewYork);

type IWLByTypeOptions<TReturn> = PartialIWLOptionsByType<TReturn> | ExhaustiveIWLOptionsByType<TReturn>;

export const matchIWLByType = <TReturn>(options: IWLByTypeOptions<TReturn>) => (app: IWL): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryIwl':
    case 'ValidOrdinaryIwl':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupIWL':
    case 'ValidGroupIWL':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkIWL':
    case 'ValidNewYorkIWL':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidIWL = (iwl: IWL) =>
  iwl.key === 'ValidOrdinaryIwl' || iwl.key === 'ValidGroupIWL' || iwl.key === 'ValidNewYorkIWL';

export type riderCodeType = {code: string; units: number[]};

//GROUP
export const groupRiderCodes = [
  {
    code: 'GWCTI',
    units: [],
  },
  {
    code: 'GWCCI',
    units: [50, 100],
  },
  {
    code: 'GWCCT',
    units: [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
  },
  {
    code: 'GWCTYT',
    units: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
  },
  {
    code: 'GWCWP',
    units: [],
  },
  {
    code: 'GWCADB',
    units: [],
  },
  {
    code: 'GWCST',
    units: [],
  },
  {
    code: 'GWCLTC',
    units: [],
  },
  {
    code: 'GWCLTCE',
    units: [],
  },
  {
    code: 'GWCLTCR',
    units: [],
  },
  {
    code: 'GWCLTCRE',
    units: [],
  },
];

export const getAllGroupRiderCodes = () => {
  return groupRiderCodes;
};

export const getGroupRiderUnits = (riderCode: string | undefined) => {
  if (riderCode !== undefined && riderCode !== 'None' && riderCode !== '') {
    const index = groupRiderCodes.findIndex(rc => rc.code === riderCode);
    return groupRiderCodes[index].units;
  }
  return [];
};
